export default "__VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__$_?url=true&w=1200&format=jpg&quality=80__"